module.exports = __webpack_public_path__ + "media/icons/collection-af25609b.svg";